module.exports = __webpack_public_path__ + "img/resume.53de8986.jpg";